exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popover-rewrite{padding-top:4px !important}.popover-rewrite .bui-popover-panel{padding:0 !important}\n", ""]);

